'use es6';

import createReactClass from 'create-react-class';
import React from 'react';
import { classNameFix, commonPropTypes, I18nCommonMixin, getPassThroughProps } from './utils';
export default createReactClass({
  displayName: "FormattedMessage",
  mixins: [I18nCommonMixin],
  propTypes: commonPropTypes,
  render: function render() {
    var __message = this.props.message;
    var props = classNameFix(getPassThroughProps(this.props));
    return React.createElement("i18n-string", props, this._getValue(true));
  }
});